import paths from "@ingka/icons-shared/paths/incorrect";
import { renderPaths } from "../renderPaths.mjs";
var incorrect_default = () => renderPaths(paths);
export {
  incorrect_default as default
};
